/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactPin extends models.AgentFieldsBase {
    getFixupPrototypeFunction() { return ArtifactPin.fixupPrototype; }

    static newInstance(model: Partial<ArtifactPin>): ArtifactPin {
        let obj = Object.assign(new ArtifactPin(), model);
        ArtifactPin.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactPin>): ArtifactPin {
        if (!model) return null;
        return ArtifactPin.newInstance(<ArtifactPin> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactPin) {
        if (!obj) return;

        models.ArtifactPin.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactPin): boolean {
        if (models.AgentFieldsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ArtifactPin.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.next_refresh_at === "string") {
            this.next_refresh_at = new Date(<string><any>this.next_refresh_at);
        }
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Name of the user who pinned the artifact.
     */
    created_by: string;

    /**
     * ID of the agent this pin is scoped to
     */
    agent_id: string;

    /**
     * ID of the pinned artifact
     */
    artifact_id: string;

    /**
     * Reserved for the (not-yet-implemented) auto-refresh job
     */
    next_refresh_at: Date;

}
